import { configGetSettings } from 'common/helper/config/get-settings';
import { preactMarkup } from 'common/helper/preact/markup';
import { BuildingReviewLandingAutocompleteStoreFactory } from 'common/module/building-review-landing/autocomplete/store.factory';
import { BuildingReviewLandingView } from 'common/module/building-review-landing/view';
import { BuildingReviewLandingAutocompleteStatechartService } from 'common/service/building-review-landing-autocomplete-statechart/service';
import { StatsGtmProviderService } from 'common/service/stats-gtm-provider/service';
import { StatsSnowplow2ProviderService } from 'common/service/stats-snowplow2-provider/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { BuildingReviewLandingFormComponent } from 'desktop/module/building-review-landing/form/component';
import { BuildingReviewLandingStrategyFactory } from 'desktop/module/building-review-landing/strategy.factory';
import { BuildingReviewLandingWriteReviewComponent } from 'desktop/module/building-review-landing/write-review/component';
import { BuildingReviewLandingAutocompleteService } from 'desktop/service/building-review-landing-autocomplete/service';

export function BuildingReviewLandingViewFactory(): BuildingReviewLandingView {
  return new BuildingReviewLandingView(
    preactMarkup,
    BuildingReviewLandingAutocompleteService(),
    BuildingReviewLandingAutocompleteStatechartService(),
    BuildingReviewLandingAutocompleteStoreFactory(),
    BuildingReviewLandingStrategyFactory(),
    {
      BuildingReviewLandingFormComponent,
      BuildingReviewLandingWriteReviewComponent,
    },
    UserAuthenticationService(),
    StatsGtmProviderService(),
    StatsSnowplow2ProviderService(),
    configGetSettings()
  );
}
